import React from "react";
import './DeleteRobotSkeleton.css';

export default function DeleteRobotSkeleton() {
  return (
    <>
      <div className="teamSelection">
        <div className="teamName"></div>
        <div className="teamImage"></div>
      </div>
      <div className="teamSelection">
        <div className="teamName"></div>
        <div className="teamImage"></div>
      </div>
      <div className="teamSelection">
        <div className="teamName"></div>
        <div className="teamImage"></div>
      </div>
      <div className="teamSelection">
        <div className="teamName"></div>
        <div className="teamImage"></div>
      </div>
      <div className="teamSelection">
        <div className="teamName"></div>
        <div className="teamImage"></div>
      </div>
      <div className="teamSelection">
        <div className="teamName"></div>
        <div className="teamImage"></div>
      </div>
    </>
  );
}